interface ActionTypes {
  GET_ENQUIRY_DETAILS_START: string;
  GET_ENQUIRY_DETAILS_SUCCESS: string;
  GET_ENQUIRY_DETAILS_FAILURE: string;
  DOWNLOAD_COMBINED_PDF_START: string;
  DOWNLOAD_COMBINED_PDF_SUCCESS: string;
  DOWNLOAD_COMBINED_PDF_FAILURE: string;
  DOWNLOAD_COMBINED_ZIP_START: string;
  DOWNLOAD_COMBINED_ZIP_SUCCESS: string;
  DOWNLOAD_COMBINED_ZIP_FAILURE: string;
}

export const DetailsPanelActionTypes: ActionTypes = {
  GET_ENQUIRY_DETAILS_START: '@@GET_ENQUIRY_DETAILS_START',
  GET_ENQUIRY_DETAILS_SUCCESS: '@@GET_ENQUIRY_DETAILS_SUCCESS',
  GET_ENQUIRY_DETAILS_FAILURE: '@@GET_ENQUIRY_DETAILS_FAILURE',
  DOWNLOAD_COMBINED_PDF_START: '@@DOWNLOAD_COMBINED_PDF_START',
  DOWNLOAD_COMBINED_PDF_SUCCESS: '@@DOWNLOAD_COMBINED_PDF_SUCCESS',
  DOWNLOAD_COMBINED_PDF_FAILURE: '@@DOWNLOAD_COMBINED_PDF_FAILURE',
  DOWNLOAD_COMBINED_ZIP_START: '@@DOWNLOAD_COMBINED_ZIP_START',
  DOWNLOAD_COMBINED_ZIP_SUCCESS: '@@DOWNLOAD_COMBINED_ZIP_SUCCESS',
  DOWNLOAD_COMBINED_ZIP_FAILURE: '@@DOWNLOAD_COMBINED_ZIP_FAILURE'
};

export interface DetailsPanelState {
  enquiryDetails?: any;
  isLoadingEnquiryDetails?: boolean;
  combinedPDFDownloadURL?: any;
  isDownloadingCombinedPDF?: boolean;
  combinedZIPDownloadData?: any;
  isDownloadingCombinedZIP?: boolean;
}
